export default __webpack_public_path__ + "static/media/kannada.77f0c7f5.svg";